import { render } from "./LoginHome.vue?vue&type=template&id=20a715f9&scoped=true"
import script from "./LoginHome.vue?vue&type=script&lang=js"
export * from "./LoginHome.vue?vue&type=script&lang=js"

import "./LoginHome.vue?vue&type=style&index=0&id=20a715f9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a715f9"]])

export default __exports__